<template>
  <div id="headermenu">
    <div class="logo-box l">
      <img :src="logimg" id="logo-img" class="logo">
    </div>
    <div id="top-menu" class="list-first clearfix l">
      <ul class="first-menu l clearfix" id="firstmenu">
        <li v-for="menu in menulist" class="item-first l" style="width:75px"
            v-bind:class="{select:menu.menucode==selectmenucode}" v-if="!isSupply()"
            @click="handleSelect(menu)"><i :class="menu.bigicon"></i> {{ menu.menuname }}
        </li>
      </ul>
      <a href="javascript:void(0)" class="menu-down l"></a>
    </div>
    <div class="top-right-content r">
      <div class="top-right l">
        <a style="cursor: pointer" class="RiconChange" v-bind:class="{hidden:hiddenriconchange}" v-if="!oSys"
           ref="RiconChange"
           title="切换账号" @click="Showriconchange(true)">
          <i class="remind-msg-num hidden"></i>
        </a>
        <a style="cursor: pointer" class="AddressList" ref="AddressList" title="通讯录"
           @click="ShoworgSearch(true)">
        </a>
        <div class="center-line l"></div>
        <div id="top-user" class="user l" v-on:mouseover="ShowUserHTML(true)"
             v-on:mouseout="ShowUserHTML(false)">
          <img :src="myphotourl" onerror="this.src='../../../static/img/mypicture.png'" id="head-img"
               class="head-img l"
               @click="myPhotoSet()">
          <span class="user_name">{{userModel.uname}}</span>
          <transition name="el-zoom-in-center">
            <div class="user-box" v-show="showuserbox">
              <div class="info">
                <img id="drop-head-img" onerror="this.src='../../../static/img/mypicture.png'"
                     :src="myphotourl"
                     class="big-head l" @click="myPhotoSet()">
                <div class="user-txt l">
                  <p class="username">{{userModel.dname}}</p>
                  <p class="departname">{{userModel.mobile}}</p>
                </div>
              </div>
              <ul class="setting">
                <!--<li class="setting-item personal" @click="employEdit()">个人资料</li>-->
                <li class="setting-item changemobile" @click="ChangePhone()">变更手机</li>
                <li class="setting-item changepassword no-border" @click="ChangePassWord()">修改密码</li>
              </ul>
              <div class="cancel-out">
                <a class="loginout l" @click="logout()">退 出</a>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <transition name="el-zoom-in-center">
        <div id="right-panel" class="right-panel" v-show="showrightpanel">
          <!-- 切换 -->
          <div id="changeAccount" class="account-panel-detail" v-bind:class="{hidden:hidechangeAccount}">
            <h2 class="account-panel-head">
              切换账号
              <i class="account-panel-hide" @click="Showriconchange(false)"></i>
            </h2>
            <input type="text" class="org-srh-input" v-model="searchTenantName" placeholder="输入关键字">
            <div class="account-panel-content" tabindex="2" style="overflow: hidden; outline: none;">
              <ul class="account-search-list"
                  style="overflow: auto; outline: none; cursor: -webkit-grab;">
                <li v-for="tenant in tenantlist" class="account-search-item" v-if="!searchTenantName||tenant.tenantname.indexOf(searchTenantName)>-1"
                    v-bind:class="{hidden:tenant.noshow}"
                    @click="handleSelectTenant(tenant)">{{ tenant.tenantname }}
                </li>
              </ul>
            </div>
          </div>
          <!-- 通讯录 -->
          <div id="orgSearch" class="account-panel-detail" v-bind:class="{hidden:hideorgSearch}">
            <h2 class="account-panel-head">
              通讯录
              <i class="account-panel-hide" @click="ShoworgSearch(false)"></i>
            </h2>
            <div class="org-panel-srh">
              <i class="org-srh-icon" @click="bindTXLGrid"></i>
              <input type="text" class="org-srh-input" v-model="searchdata" placeholder="输入关键字，回车进行搜索"
                     @keyup.enter="searchTXL">
            </div>
            <div class="account-panel-content">
              <Pagination ref="pagination1" @bindgrid="bindTXLGrid" :pagination="pagination"
                          :layout="'prev, pager, next'"></Pagination>
              <el-table
                :data="txlData"
                size="mini"
                stripe
                style="width: 100%;" :show-header="false">
                <el-table-column align="center" header-align="center" width="40" class-name="txlTD">
                  <template slot-scope="scope">
                    <img :src="PhotoPre+scope.row.uguid+'/p.png'"
                         onerror="this.src='../../../static/img/1x1.png'"
                         class="head-img">
                  </template>
                </el-table-column>
                <el-table-column label="姓名" prop="uname" align="left" header-align="center" width="60"
                                 class-name="txlTD">
                </el-table-column>
                <el-table-column class-name="txlTD"
                                 prop="mobile"
                                 label="手机号"
                                 align="left" header-align="center"
                                 width="100">
                </el-table-column>
                <el-table-column class-name="txlTD"
                                 prop="dname"
                                 label="部门"
                                 align="left" header-align="center">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <ChangePass ref="ChangePass"></ChangePass>
    <ChangePhone ref="ChangePhone" @logout="logout"></ChangePhone>
    <MyEdit ref="MyEdit"></MyEdit>
    <CropUpload ref="CropUpload" @uploadSuccess="AfterUploadPhoto"></CropUpload>
    <water-mark :options="options" :text="optiontext" v-if="showwatermark" tileWidth="360" opacity="0.1" tileHeight="360"></water-mark>
  </div>
</template>
<script>
  import ChangePass from './ChangePass'
  import ChangePhone from './ChangePhone'
  import CropUpload from '../common/CropUpload'
  import MyEdit from '../set/employee/MyEdit'
  import {getViewurl} from '@/api/attachment'
  import {logout, getMenu, setTenant, getTenantSet, getUserByToken,checkModuleRight,OldSys} from '@/api/login'
  import {getTXLList} from '@/api/set/employee'

  export default {
    inject: ["reload"],
    name: "Header",
    data() {
      return {
        oSys:false,
        showwatermark:true,
        daiGuansend:false,
        PhotoPre: "",
        HasBindTXL: false,
        optiontext:'',
        menulist: [],
        tenantlist: [],
        applist: [],
        selectmenucode: '',
        activeIndex: '/index/home',
        userModel: [],
        txlData: [],
        searchdata: '',
        searchTenantName:'',
        showuserbox: false,
        hiddenriconchange: true,
        showrightpanel: false,
        hidechangeAccount: true,
        hideorgSearch: true,
        myphotourl: "",
        logimg: "",
        machinecode: '',//机器码
        tenantCheckTimer: null,//租户变更检测定时器（其他页签切换租户时本窗口自动刷新；本窗口切换租户时需先停掉）
        options: {
          type: 'text',
          text: 'Confidential',
          fontSize: '30px',
          fontColor: '#ccc',
          opacity: 0.5,
          rotate: -30,
          position: [0, 0],
          zIndex: 999999,
          pageWidth: '50vw',
          pageHeight: '100vh',
          pagePadding: '0'
        },
        pagination: {
          currentPage: 1,
          pageSize: 0,
          total: 0
        },
      };
    },
    methods: {
      //获取本地机器码
      StartWebSocket() {
        var that = this
        var url = "ws://127.0.0.1:5000/";
        var ws = ''
        if ('WebSocket' in window) {
          ws = new WebSocket(url);
        } else if ('MozWebSocket' in window) {
          ws = new MozWebSocket(url);
        }
        ws.onopen = function () {
          // this.m_isConnectWS = true;
          console.log("Connection open ...");
          var msg = "{\"method\":\"getregistercode\"}";
          ws.send(msg);
        };
        ws.onerror = function () {
          console.log("Connection error ...");
        }
        ws.onmessage = function (e) {
          var data = e.data;
          that.machinecode = data
          console.log("data" + data)
        }
        ws.onclose = function () {
          // this.m_isConnectWS = false;
          console.log("连接中断");
        };
      },
      //判断是否供应商登录
      isSupply() {
        return JSON.parse(localStorage.getItem("hpapi_tokenModel")).loginfrom == "supply"
      },
      searchTXL(ev) {
        if (ev.keyCode == 13)
          this.bindTXLGrid();
      },
      bindTXLGrid() {
        getTXLList({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          search: this.searchdata
        }).then(response => {
          this.txlData = response.data.obj.rows;
          this.pagination.total = response.data.obj.total;
        }).catch((error) => {
        });
      },
      handleSelect(row) {
        if(row.menuurl.startsWith("/")){
          this.openNewwindow(row.menuurl);
        }else if (this.selectmenucode != row.menucode) {
          this.selectmenucode = row.menucode;
          //导向页面
          this.$router.push({name: row.menuurl, params: {menuname: row.menuname, menucode: row.menucode}})
        }
      },
      openNewwindow(menuurl) {
        window.open(window.location.origin+menuurl);
      },
      ShowUserHTML(ifshow) {
        this.showuserbox = ifshow;
      },
      Showriconchange(ifshow) {
        if (this.tenantlist.length == 2) {//无需选择
          for (var i = 0, l = this.tenantlist.length; i < l; i++) {
            if (!this.tenantlist[i].noshow) {
              var tenantDo = this.tenantlist[i];
              this.handleSelectTenant(tenantDo);
            }
          }
        }
        else {
          if (ifshow && !this.hidechangeAccount) {
            ifshow = false;
          }

          this.showrightpanel = ifshow;
          this.hidechangeAccount = !ifshow;
          this.hideorgSearch = true;
        }
      },
      getMonth2(num){
        if(num<10) return '0'+num;
        return num.toString();
      },
      ShoworgSearch(ifshow) {
        if (ifshow && !this.hideorgSearch) {
          ifshow = false;
        }
        if (!this.HasBindTXL) {
          var CH = document.documentElement.clientHeight;
          this.pagination.pageSize = CH >= 1000 ? 20 : CH >= 800 ? 15 : 10;
          this.bindTXLGrid();
          this.HasBindTXL = true;
        }
        this.showrightpanel = ifshow;
        this.hidechangeAccount = true;
        this.hideorgSearch = !ifshow;
      },
      FirstMenu() {//加载一级菜单
        this.noset = false;
        var userinfo = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
        var da=new Date();
        this.optiontext=userinfo.dname+' '+userinfo.uname+' '+da.getFullYear().toString().substr(2,2)+this.getMonth2(da.getMonth()+1)+this.getMonth2(da.getDate());
        this.$nextTick(() => {
          getMenu({MenuCode: '', AppGuid: (localStorage.getItem("appguid") || "")}).then(response => {
            var ml = response.data.menu;

            this.daiGuansend = userinfo.myright.indexOf('代管仓库发货') != -1;

            if(this.daiGuansend) {
              ml = [{
                "menucode": "0004",
                "menuname": "仓库",
                "menuurl": "store",
                "bigicon": "iconfont icon-daishouhuo"
              }];
            }
            this.selectmenucode = ml[0].menucode;
            this.menulist = ml;
            this.$router.push({name: ml[0].menuurl});
            //个人信息
            this.userModel = userinfo;
            //多企业信息
            var tokenInfo = JSON.parse(localStorage.getItem("hpapi_tokenModel"));
            if (tokenInfo.tenantDO.length > 1) {//只有一个企业的时候 不需要切换 ，只有2个的 直接切换 无需选择
              this.hiddenriconchange = false;
              for (var i = 0, l = tokenInfo.tenantDO.length; i < l; i++) {
                tokenInfo.tenantDO[i].noshow = tokenInfo.tenantDO[i].unitguid == userinfo.tenantid &&
                  tokenInfo.tenantDO[i].uguid == userinfo.uguid && tokenInfo.tenantDO[i].appguid == localStorage.getItem("appguid");
              }
            }
            this.tenantlist = tokenInfo.tenantDO;
            this.myphotourl = tokenInfo.attviewpath + "/" + userinfo.tenantid + "/myphoto/" + userinfo.uguid + "/p.png";
            this.PhotoPre = tokenInfo.attviewpath + "/" + userinfo.tenantid + "/myphoto/";
            this.startTenantCheck();
            this.changeLogImg();
          }).catch((error) => {
            console.log(error)
          });
        });
      },
      //启动租户变更检测：其他窗口/页签切换租户会改写全局 hpapi_userInfoModel，
      //本窗口检测到 tenantid 变化后跳转 '/' 重新加载，保持与最新租户一致
      startTenantCheck() {
        this.stopTenantCheck();//防止重复创建
        var userinfo = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
        var tenantid = userinfo ? userinfo.tenantid : '';
        this.tenantCheckTimer = setInterval(function () {
          var tokenNow = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
          if (tokenNow != null && tokenNow.tenantid != tenantid) {
            window.location.href = '/';
          }
        }, 5000);
      },
      stopTenantCheck() {
        if (this.tenantCheckTimer) {
          clearInterval(this.tenantCheckTimer);
          this.tenantCheckTimer = null;
        }
      },
      handleSelectTenant(row) {//切换租户
        //本窗口主动切换租户会改写全局 hpapi_userInfoModel，先停掉检测定时器，
        //避免切换过程中被定时器当成"其他页面切换租户"而多刷新一次
        this.stopTenantCheck();
        var isTenantChanged = false;
        if (localStorage.getItem("tenantid") != row.unitguid) {
          isTenantChanged = true;
        }
        var isAppChanged = false;
        if (localStorage.getItem("appguid") != row.appguid) {
          isAppChanged = true;
        }
        var appurl = row.appurl + "?appguid=" + row.appguid
          + "&tenantid=" + row.unitguid
          + "&token=" + localStorage.getItem("hpapi_token");

        setTenant({
          tenantID: row.unitguid,
          uguid: row.uguid,
          appguid: row.appguid,
          machinecode: this.machinecode,//机器码
          apiurl: row.apiurl,
          isAppChanged: isAppChanged,
        }).then(responseUser => {
          if (responseUser.data.code == 0) {
            localStorage.setItem("hpapi_userInfoModel", JSON.stringify(responseUser.data.obj));
            document.title = responseUser.data.obj.tenantname ;

            if (isTenantChanged) {//切换了不同公司
              var host = window.location.host;
              if (row.appurl.indexOf(host) == -1) {
                //切换了域名
                window.location.href = appurl;
              } else {
                //未切换域名
                window.location.href = appurl;
                this.$router.go(0)
              }
            } else {//切换了不同应用
              window.open(appurl, "_blank");
            }
          } else {//获取错误
            this.startTenantCheck();//切换失败，恢复租户变更检测
            this.$message.error({message: responseUser.data.msg});
          }
        }).catch(() => {
          this.startTenantCheck();//请求异常，恢复租户变更检测
        });
      },
      logout() {
        // alert(1)
        this.stopTenantCheck();
        logout({}).then(response => {
          let name = this.isSupply() ? "loginsupply" : "login";
          localStorage.removeItem("appguid");
          localStorage.removeItem("tenantid");
          localStorage.removeItem("hpapi_token");
          localStorage.removeItem("hpapi_tokenModel");
          localStorage.removeItem("hpapi_userInfoModel");
          window.location.href='/';
          // this.$router.push({name: name});
        }).catch((error) => {
          console.log(error)
        });
      }, ChangePassWord() {
        this.$refs.ChangePass.dialogFormVisible = true;
      }, ChangePhone() {
        this.$refs.ChangePhone.dialogFormVisible = true;
      }, myPhotoSet() {
        this.$refs.CropUpload.show = true;
      }, AfterUploadPhoto(url) {
        this.myphotourl = url;
      },
      employEdit() {
        this.$refs.MyEdit.initData(this.userModel.uguid)
        this.$refs.MyEdit.show(this.userModel.dserial, this.userModel.dname)
      },
      changeLogImg() {
        getTenantSet({"website": ''}).then(reponse => {
          localStorage.setItem("hpapi_parames", JSON.stringify(reponse.data));
          this.logimg = reponse.data.apiset.logimg;
        });
      }
    },
    mounted() {
      checkModuleRight({name: 'hidewatermark'}).then(reponse => {
        this.showwatermark = !reponse.data.code == 0;
      });
      this.oSys=OldSys();
      this.FirstMenu();
      this.StartWebSocket();
    },
    beforeDestroy() {
      this.stopTenantCheck();
    },
    components: {
      ChangePass,
      ChangePhone,
      CropUpload,
      MyEdit
    }
  }
</script>
<style scoped>
  .right-panel {
    position: absolute;
    z-index: 10;
    top: 48px;
    right: 0;
    bottom: 6px;
    width: 350px;
    border-top: 2px solid #77abe4;
    border-left: 1px solid #dfdfdf;
    background-color: #fff;
    box-shadow: -2px 0 2px 0 rgba(0, 0, 0, .15);
  }

  .account-panel-detail {
    position: relative;
    height: 100%;
  }

  .account-panel-head {
    position: relative;

    padding-left: 10px;

    font-size: 16px;
    line-height: 36px;

    color: #2586d9;
    border-bottom: 1px solid #ddd;
    background-color: #f4f4f4;
  }

  .account-panel-hide {
    position: absolute;
    top: 50%;
    right: 10px;

    width: 22px;
    height: 22px;
    margin-top: -11px;

    cursor: pointer;

    background: url('../../assets/images/icon-toright.png');
  }

  .account-panel-content {
    position: absolute;
    top: 72px;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
  }

  .account-search-list {
    position: absolute;
    top: 0px;
    bottom: 0;
    width: 100%;
  }

  .account-search-item {
    padding-left: 20px;
    line-height: 36px;
    cursor: pointer;
    color: #3d4b62;
    text-align: left;
    float: left;
    padding-right: 20px;
  }

  .account-search-item:hover {
    background-color: #dcefff;
  }

  .org-panel-srh {
    display: table;

    width: 330px;
    margin: 10px;
  }

  .org-srh-input,
  .org-srh-icon {
    display: table-cell;
  }

  .org-srh-icon {
    cursor: pointer;
    width: 35px;
    background: url(../../assets/images/search-bg.png);
  }

  .org-srh-input {
    width: 288px;
    height: 28px;
    padding-left: 6px;

    font-size: 12px;
    line-height: 28px;

    color: #666;
    border: 1px solid #2a92eb;
    border-left: 0;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
    outline: none;
  }

  .org-search-result {
    height: 100%;
  }
</style>

<style>

  .txlTD {
    padding: 4px 0 !important;
  }

</style>

<style scoped>
  .logo-box {
    overflow: hidden;
    width: 250px;
    height: 48px;
  }

  .logo {
    display: block;
    margin: 0px 0 0 0px;
  }

  .l {
    float: left;
  }

  .list-first {
    position: relative;
    z-index: 10;
    overflow: hidden;
    width: 900px;
    height: 40px;
    margin-top: 5px;
    margin-right: 8px;
    margin-left: 8px;
    border-radius: 4px;
  }

  .item-first.select {
    color: #fff;
    background: #2590eb;
  }

  .item-first:hover {
    background: #5987c6;
  }

  .item-first.select:hover {
    background: #2590eb;
  }

  .item-first {
    overflow: hidden;
    width: 90px;
    height: 30px;
    margin: 2px 2px;
    font-size: 14px;
    line-height: 30px;
    cursor: pointer;
    -webkit-transition: all .6s cubic-bezier(.25, .46, .45, .94);
    transition: all .6s cubic-bezier(.25, .46, .45, .94);
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #cce2ff;
    border-radius: 4px;
  }

  .first-menu {
    width: 900px;
    margin-right: 6px;
    margin-top: 3px;
  }

  .menu-down {
    display: none;
    width: 28px;
    height: 28px;
    margin: 5px 5px 0 5px;
    background: url(../../assets/images/first-menu-btn.png);
  }

  .top-right-content {
    margin-right: 5px;
  }

  .r {
    float: right !important;
  }

  .top-right {
    padding-top: 10px;
  }

  .top-right > a {
    display: block;
    float: left;
    width: 24px;
    height: 24px;
    margin-top: 2px;
    margin-right: 10px;
  }

  .setup {
    background: url(../../assets/images/yejie.png);
  }

  .setup:hover {
    background: url(../../assets/images/yejie-active.png);
  }

  .qrcode {
    background: url(../../assets/images/qrcode.png);
  }

  .qrcode:hover {
    background: url(../../assets/images/qrcode-active.png);
  }

  .RiconChange {
    background: url(../../assets/images/RiconChange.png);
  }

  .RiconChange:hover {
    background: url(../../assets/images/RiconChange-active.png);
  }

  .AddressList {
    background: url(../../assets/images/AddressList.png);
  }

  .AddressList:hover {
    background: url(../../assets/images/AddressList-active.png);
  }

  .remind-num, .remind-msg-num {
    position: absolute;
    display: block;
    height: 13px;
    margin: -5px 0 0 15px;
    padding: 0 3px;
    font-size: 12px;
    line-height: 13px;
    color: #fff;
    border-radius: 6px;
    background: #f73f07;
  }

  .hidden {
    display: none !important;
  }

  .center-line {
    width: 0;
    height: 22px;
    margin-top: 3px;
    margin-right: 10px;
    border-left: 1px solid #92add2;
  }

  .head-img {
    display: block;
    width: 28px;
    height: 28px;
    cursor: pointer;
    border-radius: 50%;
    padding: 0px;
    background-color: #fff;
    border: 0px solid rgba(0, 0, 0, 0.15);
  }

  .user {
    width: 90px;
  }

  .user_name {
    color: #fff;
    padding: 8px;
    line-height: 26px;
    font-size: 14px;
    cursor: pointer;
  }

  .user-box {
    position: absolute;
    z-index: 10;
    width: 188px;
    margin-top: 12px;
    margin-left: -96px;
    padding-top: 0px;
  }

  .info {
    height: 62px;
    border-bottom: 1px solid #3a7bd3;
    background: #346dba;
  }

  .big-head {
    display: block;
    width: 46px;
    height: 46px;
    margin: 5px 15px 0 15px;
    cursor: pointer;
    display: block;
    padding: 1px;
    background-color: #fff;
    border: 0px solid rgba(0, 0, 0, 0.15);
    overflow: hidden;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .user {
    height: 45px;
  }

  .user-txt {
    margin-top: 6px;
    width: 96px;
    text-align: left;
  }

  .username {
    font-size: 15px;
    color: #fff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .departname {
    font-size: 12px;
    color: #fff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .setting {
    border-bottom: 1px solid #3a7bd3;
    height: 60px;
  }

  .setting-item {
    float: left;
    width: 92px;
    padding-top: 38px;
    cursor: pointer;
    -webkit-transition: all .6s cubic-bezier(.25, .46, .45, .94);
    transition: all .6s cubic-bezier(.25, .46, .45, .94);
    text-align: center;
    color: #fff;
    border-right: 1px solid #3a7bd3;
    background-color: #346dba !important;
  }

  .setting-item:hover {
    background-color: #185197 !important;
  }

  .personal {
    background: url(../../assets/images/p-head.png) center 12px no-repeat;
  }

  .changemobile {
    background: url(../../assets/images/setting.png) center 12px no-repeat;
  }

  .changepassword {
    background: url(../../assets/images/function.png) center 11px no-repeat;
  }

  .no-border {
    border: none;
  }

  .cancel-out {
    padding-top: 10px;
    padding-left: 12px;
    background: #346dba;
    height: 48px;
    cursor: pointer;
  }

  .loginout {
    display: inline-block;
    width: 160px;
    height: 36px;
    font-size: 15px;
    line-height: 36px;
    -webkit-transition: background .6s cubic-bezier(.25, .46, .45, .94);
    transition: background .6s cubic-bezier(.25, .46, .45, .94);
    text-align: center;
    color: #fff;
    border-radius: 4px;
    background: #f96d41;
  }

  .loginout:hover {
    background: #ff812d;
  }

  li {
    display: list-item;
    text-align: -webkit-match-parent;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/Header.vue